(() => {
  const cache = new Map();
  const pageCache = new Map();

  const ACTIVE = "pl-swatches-collection__swatch-wrapper--active";
  const CARD_SELECTOR = ".m-product-card, .na-card, .m-cascading-product-card";

  let productSwapId = 0;
  let reloadTimer = 0;
  let dedupeTimer = 0;

  function handleFromUrl(href) {
    const match = (href || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function sizedUrl(url, width) {
    if (!url) return "";

    const abs = url.startsWith("//") ? `https:${url}` : url;

    return abs.includes("?")
      ? `${abs}&width=${width}`
      : `${abs}?width=${width}`;
  }

  function setImg(img, url) {
    if (!img || !url) return;

    img.src = sizedUrl(url, 1100);
    img.removeAttribute("srcset");
  }

  function fetchProduct(handle) {
    if (cache.has(handle)) {
      return cache.get(handle);
    }

    const root =
      (window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root) ||
      "/";

    const req = fetch(`${root}products/${handle}.js`).then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.json();
    });

    cache.set(handle, req);

    return req;
  }

  function fetchPage(url) {
    if (pageCache.has(url)) {
      return pageCache.get(url);
    }

    const req = fetch(url).then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.text();
    });

    pageCache.set(url, req);

    return req;
  }

  function modifiedClick(event) {
    return (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    );
  }

  function findCard(node) {
    return node.closest(CARD_SELECTOR);
  }

  function formatPrice(cents) {
    const moneyFormat =
      window.MinimogSettings &&
      MinimogSettings.money_format;

    if (
      !moneyFormat ||
      typeof formatMoney !== "function"
    ) {
      return "";
    }

    return formatMoney(cents, moneyFormat);
  }

  function reloadCollectionSwatches() {
    window.clearTimeout(reloadTimer);

    reloadTimer = window.setTimeout(() => {
      if (
        window.PlatmartSwatchesCollection &&
        typeof PlatmartSwatchesCollection.load === "function"
      ) {
        PlatmartSwatchesCollection.load();
      }

      scheduleCollectionDedupe();
    }, 250);
  }

  function scheduleCollectionDedupe() {
    window.clearTimeout(dedupeTimer);

    dedupeTimer = window.setTimeout(() => {
      dedupeCollectionGroups();
    }, 350);
  }

  function dedupeCollectionGroups() {
    const template =
      document.documentElement.dataset.template || "";

    if (!template.includes("collection")) {
      return;
    }

    const seenGroups = new Map();

    document
      .querySelectorAll(CARD_SELECTOR)
      .forEach((card) => {
        const swatchGroup = card.querySelector(
          ".pl-swatches-collection"
        );

        if (!swatchGroup) {
          return;
        }

        const links = Array.from(
          swatchGroup.querySelectorAll(
            "a.pl-swatches-collection__link"
          )
        );

        if (links.length < 2) {
          return;
        }

        const handles = links
          .map((link) =>
            handleFromUrl(link.getAttribute("href"))
          )
          .filter(Boolean)
          .sort();

        if (handles.length < 2) {
          return;
        }

        const groupKey = handles.join("|");

        const item =
          card.closest(".m-product-item") ||
          card.closest("[data-product-id]") ||
          card;

        if (!seenGroups.has(groupKey)) {
          seenGroups.set(groupKey, item);

          item.hidden = false;
          item.removeAttribute(
            "data-platmart-group-duplicate"
          );

          return;
        }

        item.hidden = true;
        item.setAttribute(
          "data-platmart-group-duplicate",
          "true"
        );
      });
  }

  function swapProductPage(url, handle) {
    const productInfo = document.querySelector(
      "product-info[id^='MainProduct']"
    );

    if (
      !productInfo ||
      typeof productInfo.handleSwapProduct !==
        "function"
    ) {
      window.location.assign(url);
      return;
    }

    const requestId = ++productSwapId;

    const main = document.querySelector("main");

    if (main) {
      main.style.opacity = "0.55";
      main.style.pointerEvents = "none";
    }

    fetchPage(url)
      .then((text) => {
        if (requestId !== productSwapId) {
          return;
        }

        const html = new DOMParser().parseFromString(
          text,
          "text/html"
        );

        productInfo.handleSwapProduct(
          url,
          true,
          productInfo.viewMode
        )(html);

        if (window.MinimogSettings) {
          MinimogSettings.productHandle = handle;
        }
      })
      .catch(() => {
        if (requestId !== productSwapId) {
          return;
        }

        window.location.assign(url);
      });
  }

  function updatePrice(card, product) {
    const moneyFormat =
      window.MinimogSettings &&
      MinimogSettings.money_format;

    if (
      moneyFormat &&
      typeof formatMoney === "function"
    ) {
      card
        .querySelectorAll(".m-price")
        .forEach((priceWrapper) => {
          const salePrice =
            priceWrapper.querySelector(
              ".m-price-item--sale"
            );

          const compareAtPrice =
            priceWrapper.querySelectorAll(
              ".m-price-item--regular"
            );

          const onSale =
            product.compare_at_price &&
            product.compare_at_price >
              product.price;

          priceWrapper.classList.toggle(
            "m-price--on-sale",
            Boolean(onSale)
          );

          priceWrapper.classList.toggle(
            "m-price--sold-out",
            !product.available
          );

          if (salePrice) {
            salePrice.innerHTML = formatMoney(
              product.price,
              moneyFormat
            );
          }

          compareAtPrice.forEach((item) => {
            item.innerHTML = formatMoney(
              onSale
                ? product.compare_at_price
                : product.price,
              moneyFormat
            );
          });
        });
    }

    const naPrice =
      card.querySelector(".na-price");

    if (naPrice) {
      const priceHtml =
        formatPrice(product.price) ||
        naPrice.textContent;

      if (
        product.compare_at_price &&
        product.compare_at_price >
          product.price
      ) {
        naPrice.innerHTML =
          `${priceHtml}` +
          `<span class="na-compare">` +
          `${formatPrice(product.compare_at_price)}` +
          `</span>`;
      } else {
        naPrice.innerHTML = priceHtml;
      }
    }
  }

  function applyProduct(card, link, product) {
    const href = link.getAttribute("href");

    const variant =
      (product.variants || []).find(
        (item) => item.available
      ) ||
      (product.variants || [])[0];

    setImg(
      card.querySelector(
        ".m-product-card__main-image img, " +
        ".na-img, " +
        ".m-cascading-product-card__image-main img"
      ),
      product.featured_image
    );

    const hover = card.querySelector(
      ".m-product-card__hover-image, " +
      ".m-cascading-product-card__image-hover"
    );

    if (hover) {
      if (
        product.images &&
        product.images[1]
      ) {
        setImg(
          hover.querySelector("img"),
          product.images[1]
        );

        card.classList.add(
          "m-product-card--show-second-img"
        );
      } else {
        card.classList.remove(
          "m-product-card--show-second-img"
        );
      }
    }

    card
      .querySelectorAll(
        ".m-product-card__name, " +
        ".na-title, " +
        ".m-cascading-product-card__title h4"
      )
      .forEach((el) => {
        el.textContent = product.title;
      });

    const mediaLink = card.querySelector(
      ".m-product-card__link"
    );

    if (mediaLink) {
      mediaLink.setAttribute(
        "aria-label",
        product.title
      );
    }

    card
      .querySelectorAll(
        'a[href*="/products/"]'
      )
      .forEach((anchor) => {
        if (
          anchor.classList.contains(
            "pl-swatches-collection__link"
          )
        ) {
          return;
        }

        if (
          anchor.classList.contains(
            "pl-swatches__link"
          )
        ) {
          return;
        }

        anchor.setAttribute("href", href);
      });

    card.dataset.productId =
      String(product.id);

    card
      .querySelectorAll("[data-product-id]")
      .forEach((el) => {
        if (
          el.classList.contains(
            "pl-swatches-collection-mount"
          )
        ) {
          return;
        }

        el.setAttribute(
          "data-product-id",
          product.id
        );
      });

    card
      .querySelectorAll(
        '[name="product-id"]'
      )
      .forEach((el) => {
        el.value = product.id;
      });

    card
      .querySelectorAll(
        "[data-product-handle]"
      )
      .forEach((el) => {
        el.setAttribute(
          "data-product-handle",
          product.handle
        );
      });

    if (variant) {
      card
        .querySelectorAll('input[name="id"]')
        .forEach((el) => {
          el.value = variant.id;
          el.setAttribute(
            "value",
            variant.id
          );
        });
    }

    const onSale =
      product.compare_at_price &&
      product.compare_at_price >
        product.price;

    card.classList.toggle(
      "m-product-card--soldout",
      !product.available
    );

    card.classList.toggle(
      "m-product-card--onsale",
      Boolean(onSale)
    );

    const soldBadge =
      card.querySelector(
        ".m-product-tag--soldout"
      );

    if (soldBadge) {
      soldBadge.style.display =
        product.available
          ? "none"
          : "flex";
    }

    card
      .querySelectorAll(
        ".m-add-to-cart, [name='add']"
      )
      .forEach((btn) => {
        btn.classList.toggle(
          "disabled",
          !product.available
        );
      });

    updatePrice(card, product);

    const group = link.closest(
      ".pl-swatches-collection"
    );

    if (group) {
      group
        .querySelectorAll(`.${ACTIVE}`)
        .forEach((el) =>
          el.classList.remove(ACTIVE)
        );

      group
        .querySelectorAll("[aria-current]")
        .forEach((el) =>
          el.removeAttribute(
            "aria-current"
          )
        );

      const wrap = link.querySelector(
        ".pl-swatches-collection__swatch-wrapper"
      );

      if (wrap) {
        wrap.classList.add(ACTIVE);
      }

      link.setAttribute(
        "aria-current",
        "page"
      );
    }
  }

  document.addEventListener(
    "click",
    (event) => {
      const productLink =
        event.target.closest &&
        event.target.closest(
          "a.pl-swatches__link"
        );

      if (
        productLink &&
        productLink.closest("product-info")
      ) {
        if (modifiedClick(event)) {
          return;
        }

        if (
          productLink.getAttribute(
            "aria-current"
          ) === "page"
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const href =
          productLink.getAttribute("href");

        const handle =
          productLink.dataset.handle ||
          handleFromUrl(href);

        if (
          !href ||
          href.indexOf("javascript") === 0 ||
          !handle
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        swapProductPage(
          href,
          handle
        );

        return;
      }

      const link =
        event.target.closest &&
        event.target.closest(
          "a.pl-swatches-collection__link"
        );

      if (!link) {
        return;
      }

      if (modifiedClick(event)) {
        return;
      }

      const handle = handleFromUrl(
        link.getAttribute("href")
      );

      if (!handle) {
        return;
      }

      const card = findCard(link);

      if (!card) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (
        link.getAttribute(
          "aria-current"
        ) === "page"
      ) {
        return;
      }

      fetchProduct(handle)
        .then((product) =>
          applyProduct(
            card,
            link,
            product
          )
        )
        .catch(() => {});
    },
    true
  );

  document.addEventListener(
    "mouseover",
    (event) => {
      const productLink =
        event.target.closest &&
        event.target.closest(
          "a.pl-swatches__link"
        );

      if (
        productLink &&
        productLink.closest("product-info")
      ) {
        const href =
          productLink.getAttribute("href");

        if (
          href &&
          href.indexOf("javascript") !== 0
        ) {
          fetchPage(href).catch(
            () => {}
          );
        }

        return;
      }

      const link =
        event.target.closest &&
        event.target.closest(
          "a.pl-swatches-collection__link"
        );

      if (!link) {
        return;
      }

      const handle = handleFromUrl(
        link.getAttribute("href")
      );

      if (handle) {
        fetchProduct(handle).catch(
          () => {}
        );
      }
    },
    true
  );

  document.addEventListener(
    "shopify:section:load",
    reloadCollectionSwatches
  );

  const observer =
    new MutationObserver((mutations) => {
      let shouldReload = false;
      let shouldDedupe = false;

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) {
            continue;
          }

          if (
            node.classList &&
            node.classList.contains(
              "pl-swatches-collection"
            )
          ) {
            shouldDedupe = true;
            continue;
          }

          if (
            node.matches?.(CARD_SELECTOR) ||
            node.matches?.(
              "[data-pl-swatches-collection]"
            ) ||
            node.querySelector?.(
              CARD_SELECTOR
            ) ||
            node.querySelector?.(
              "[data-pl-swatches-collection]"
            )
          ) {
            shouldDedupe = true;

            if (
              !node.querySelector?.(
                ".pl-swatches-collection"
              )
            ) {
              shouldReload = true;
            }
          }
        }
      }

      if (shouldReload) {
        reloadCollectionSwatches();
        return;
      }

      if (shouldDedupe) {
        scheduleCollectionDedupe();
      }
    });

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      reloadCollectionSwatches();
      scheduleCollectionDedupe();
    }
  );

  if (document.readyState !== "loading") {
    reloadCollectionSwatches();
    scheduleCollectionDedupe();
  }

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();